import React from "react";
import "./index.css";
import TinyCard from "../TinyCard/index";   

const Footer = (props) => {
  const { hoy } = props;
  return (
    <div className="Footer">
      {hoy.map((e, index) =>
        index > 0 ? <TinyCard desc={e.date} hoy={e.day.condition.icon} tempMinMax={e.day.mintemp_c+"°C/"+e.day.maxtemp_c+"°C"} key={index}/> : null
      )}
    </div>
  );
};

export default Footer;
